/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Complete_Signin_TitleInputs */



/**
* | output |
* | --- |
* | "Complete Sign-In" |
*
* @param {Login_Complete_Signin_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_complete_signin_title = /** @type {((inputs?: Login_Complete_Signin_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Complete_Signin_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer la Connexion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständige Anmeldung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Completa l'accesso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Завершить вход в систему")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicio de sesión completo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("完成登录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サインインを完了する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉग इन पूरा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Concluir o login")
	return /** @type {LocalizedString} */ ("Complete Sign-In")
});